import { ComponentProps } from 'react';

import { Sport, SportOrShared } from '__generated__/globalTypes';

import { Ball } from '../Ball';
import { MLBBall } from '../MLBBall';
import { NBABall } from '../NBABall';

export const SportIcon = ({
  sport,
  ...otherProps
}: ComponentProps<typeof Ball> & {
  sport: SportOrShared | Sport;
}) => {
  if (sport === SportOrShared.FOOTBALL) return <Ball {...otherProps} />;
  if (sport === SportOrShared.NBA) return <NBABall {...otherProps} />;
  if (sport === SportOrShared.BASEBALL) return <MLBBall {...otherProps} />;
  return null;
};
